import { SideNavInterface } from "../../interfaces/side_nav.type";

export const ROUTES: SideNavInterface[] = [
    {
        path: "/dashboard/home",
        title: "Dashboard",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "dashboard",
        submenu: []
    },
    {
        path: "",
        title: "Assessments",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "audit",
        submenu: []
    },
    {
        path: "/merchants/list_merchants",
        title: "Merchants / SPs",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "shop",
        submenu: [],
        requiresAdmin: true
    },
    {
        path: "/secure-storage",
        title: "Secure Storage",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "folder-open",
        submenu: [],
        matchSubRoutes: true
    }
];
